import React, { Component } from 'react';
import m2016 from '../../img/melhores2016.jpg';
import globalizacao from '../escolha/globalizacao';

class HomeAwards extends Component {


    render() {
        var lang = globalizacao.getLinguaDoUsuario();

        return (
            <section className="secao  awards fundo-white" style={{
                paddingBottom: "100px"
            }} >
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("awards")}</h2>


                    <p dangerouslySetInnerHTML={{ __html: globalizacao.msg("awardsTexto") }}>

                    </p>
                    <div style={{
                        display: lang === "pt-BR" ? "block" : "none"
                    }}>
                        <br /><br />
                        <img src={m2016} style={{
                            opacity: 0.9,
                            maxWidth: "600px",
                            width: "100%",
                            display: "block",
                            margin: "20px auto"
                        }} />
                    </div>
                    <br /><br />
                    <div style={{
                        textAlign: "center"
                    }}>
                        <a
                            target="_blank"
                            href="https://exame.com/tecnologia/estes-sao-os-36-melhores-apps-android-de-2016-segundo-o-google/"

                            className="btn-link btn-premio">
                            {globalizacao.msg("confiraPlay")}
                        </a>
                    </div>
                </div>

            </section>
        );
    }
}

export default HomeAwards;








// WEBPACK FOOTER //
// ./src/js/pages/home-awards.js